import { gql, useApolloClient, useQuery } from '@apollo/client';
import { useCallback } from 'react';

const GET_SELECTED_SCENARIO = gql`
  query GetSelectedScenario {
    selectedScenario @client
    selectedScenarioId @client
    previousScenario @client
  }
`;

export function useSelectedScenario () {
    const client = useApolloClient();
    const { data } = useQuery(GET_SELECTED_SCENARIO);

    const setSelectedScenario = useCallback((name: string, id?: string) => {
        // Get current scenario before updating
        const currentScenario = data?.selectedScenario ?? 'Main';

        if (name === 'Main') {
            // For Main scenario, explicitly clear the ID
            client.writeQuery({
                query: GET_SELECTED_SCENARIO,
                data: {
                    selectedScenario: 'Main',
                    selectedScenarioId: null,
                    previousScenario: currentScenario,
                },
            });
        } else {
            // For other scenarios, use the provided ID
            client.writeQuery({
                query: GET_SELECTED_SCENARIO,
                data: {
                    selectedScenario: name,
                    selectedScenarioId: id,
                    previousScenario: currentScenario,
                },
            });
        }
    }, [client, data?.selectedScenario]);

    const selectedScenario = data?.selectedScenario ?? 'Main';
    const selectedScenarioId = data?.selectedScenarioId ?? undefined;
    const previousScenario = data?.previousScenario ?? 'Main';
    const isMainSelected = selectedScenario === 'Main';

    return {
        selectedScenario,
        selectedScenarioId,
        previousScenario,
        isMainSelected,
        setSelectedScenario,
    };
}
